import React from "react";
import { useParams } from 'react-router-dom';
import { Box, Drawer, Group, Text, ActionIcon } from '@mantine/core';
import { IconMessageChatbot, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { canAccessModifyStepNota_Type2, canAccessModifyModulPembayaran } from "../../utils/accessing";

import ImageLightBox2 from "../../components/general/ImageLightBox2";
import VideoPlayerModal from "../../components/general/VideoPlayerModal";
import StepNota from "../../components/utilities/StepNota";
import StepNotaDibatalkan from "../../components/utilities/StepNotaDibatalkan";
import StepPengerjaan from "../../components/utilities/StepPengerjaan";
import StepSelesai from "../../components/utilities/StepSelesai";
import FeedbackDrawer from "../home/feedback/FeedbackDrawer";

const SudahDiambilSelected = ({
    fnRefreshNotaIndex,
    fnSuccessTakesThisProject,
    fnCloseDrawer,
    stateData
}) => {

    const { URI1 } = useParams();
    const { loginContext } = useLoginContext();

    const utilsRef = React.useRef({
        projectProcess: utils.projectProcess.sudah_diambil.value,
        projectIsCancel: '0',
        userAccess: [
            // role.owner.subLevel.owner.slugSubLevel,
            // role.admin.subLevel.admin_kepala.slugSubLevel,
            // role.admin.subLevel.admin_staf.slugSubLevel,
        ]
    })

    const [data, setData] = React.useState({
        imageLightboxImages: '',
        imageLightboxTitle: '',
        imageLightboxIndex: '',
        imageLightboxFieldName: '',
        imageLightboxShow: false,

        feedbackModal: false,

        mediaURL: '',
        mediaTitle: '',
        mediaShow: false,

        refreshStepSelesai: new Date(),
    });

    return (
        <React.Fragment>
            <Drawer
                opened={URI1}
                onClose={fnCloseDrawer}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}
                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnCloseDrawer}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Group position='apart' style={{ width: '100%' }}>
                            <Text>Sudah Diambil</Text>
                            <ActionIcon
                                size='lg'
                                variant="light"
                                color="green"
                                radius='xl'
                                onClick={() => setData(d => ({ ...d, feedbackModal: true }))}
                            >
                                <IconMessageChatbot size='1.25rem' stroke={1.25} />
                            </ActionIcon>
                        </Group>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        width: '100%',
                    }
                })}
            >
                {canAccessModifyStepNota_Type2({ stateObject: { subLevel: loginContext } }) ?
                    <StepNota
                        stateURI1={URI1}
                        stateUtilsRef={utilsRef.current}

                        fnRefreshNotaIndex={fnRefreshNotaIndex}

                        fnRefreshHistory={() => { }}

                        fnRefreshStepSelesai={() => setData(d => ({ ...d, refreshStepSelesai: new Date() }))}

                        fnClickPhoto={(object) => setData(d => ({
                            ...d,
                            imageLightboxImages: object.images,
                            imageLightboxTitle: object.title,
                            imageLightboxIndex: object.index,
                            imageLightboxFieldName: object.fieldName,
                            imageLightboxShow: true,
                        }))}

                        stateShowMediaQC={true}
                        fnClickMediaImageVideo={(object) => {
                            object.type === utils.mediaQCType.image.value ?
                                setData(d => ({
                                    ...d,
                                    imageLightboxImages: object.images,
                                    imageLightboxTitle: object.title,
                                    imageLightboxIndex: object.index,
                                    imageLightboxFieldName: object.fieldName,
                                    imageLightboxShow: true,
                                }))
                                :
                                setData(d => ({
                                    ...d,
                                    mediaURL: object.name,
                                    mediaTitle: object.title,
                                    mediaShow: true,
                                }))
                        }}

                        fnCloseDrawer={fnCloseDrawer}
                    />
                    :
                    <StepNotaDibatalkan
                        stateURI1={URI1}
                        stateUtilsRef={utilsRef.current}

                        fnRefreshNotaIndex={fnRefreshNotaIndex}
                        fnRefreshHistory={() => {
                            setData(d => ({ ...d, triggerRefreshHistory: new Date() }))
                        }}

                        fnClickPhoto={(object) => setData(d => ({
                            ...d,
                            imageLightboxImages: object.images,
                            imageLightboxTitle: object.title,
                            imageLightboxIndex: object.index,
                            imageLightboxFieldName: object.fieldName,
                            imageLightboxShow: true,
                        }))}

                        stateShowMediaQC={true}
                        fnClickMediaImageVideo={(object) => {
                            object.type === utils.mediaQCType.image.value ?
                                setData(d => ({
                                    ...d,
                                    imageLightboxImages: object.images,
                                    imageLightboxTitle: object.title,
                                    imageLightboxIndex: object.index,
                                    imageLightboxFieldName: object.fieldName,
                                    imageLightboxShow: true,
                                }))
                                :
                                setData(d => ({
                                    ...d,
                                    mediaURL: object.name,
                                    mediaTitle: object.title,
                                    mediaShow: true,
                                }))
                        }}

                        fnCloseDrawer={fnCloseDrawer}
                    />
                }

                <Box mt='sm' />

                <StepPengerjaan
                    stateData={{
                        projectId: URI1,

                        projectProcess: utilsRef.current.projectProcess,
                        projectIsCancel: utilsRef.current.projectIsCancel,
                        userAccess: utilsRef.current.userAccess,
                    }}

                    stateShowNextComponent={false}

                    fnClickPhoto={(object) => setData(d => ({
                        ...d,
                        imageLightboxImages: object.images,
                        imageLightboxTitle: object.title,
                        imageLightboxIndex: object.index,
                        imageLightboxFieldName: object.fieldName,
                        imageLightboxShow: true,
                    }))}

                    fnCloseDrawer={fnCloseDrawer}

                    fnSuccessTakesThisProject={() => { }}
                />

                <Box mt='sm' />

                {canAccessModifyModulPembayaran({ stateObject: { subLevel: loginContext } }) &&
                    <StepSelesai
                        stateData={{
                            projectId: URI1,

                            projectProcess: utilsRef.current.projectProcess,
                            projectIsCancel: utilsRef.current.projectIsCancel,
                            userAccess: utilsRef.current.userAccess,
                            refreshStepSelesai: data.refreshStepSelesai
                        }}

                        stateShowNextComponent={false}

                        fnClickPhoto={(object) => setData(d => ({
                            ...d,
                            imageLightboxImages: object.images,
                            imageLightboxTitle: object.title,
                            imageLightboxIndex: object.index,
                            imageLightboxFieldName: object.fieldName,
                            imageLightboxShow: true,
                        }))}

                        fnCloseDrawer={fnCloseDrawer}

                        fnSuccessTakesThisProject={fnSuccessTakesThisProject}

                        fnRefreshSudahDiambilIndex={fnRefreshNotaIndex}
                    />
                }
            </Drawer>

            <ImageLightBox2
                stateImages={Array.isArray(data.imageLightboxImages) && (data.imageLightboxImages.length > 0) ? data.imageLightboxImages.map(key => ROOT_BASE_URL + key[data.imageLightboxFieldName]) : []}

                stateTitle={data.imageLightboxTitle}
                stateSelectedIndex={data.imageLightboxIndex}
                stateShow={data.imageLightboxShow}
                fnShow={() => setData(d => ({ ...d, imageLightboxShow: false }))}
            />

            <VideoPlayerModal
                stateURL={data.mediaURL}
                stateTitle={data.mediaTitle}
                stateShow={data.mediaShow}
                fnShow={() => setData(d => ({ ...d, mediaShow: false }))}
            />

            <FeedbackDrawer
                stateShow={data.feedbackModal}
                fnShow={(val) => setData(d => ({ ...d, feedbackModal: val }))}
                stateData={{
                    data: stateData.data,
                }}
                fnShouldUpdateIndex={fnRefreshNotaIndex}
            />
        </React.Fragment>
    )
}

export default React.memo(SudahDiambilSelected);